<template>
  <div>
    <form @submit.prevent>
      <div class="form-group control has-icons-right">
        <ValidationProvider
          ref="bikeMakeObserver"
          v-slot="{ errors }"
          rules="required"
        >
          <input
            id="bike-make"
            v-model="_bike.make"
            :class="{ 'is-danger': errors[0] }"
            type="text"
            class="input"
            required
          />
          <label class="form-control-placeholder" for="bike-make">
            Bike Make*
          </label>
          <span v-if="errors[0]" class="icon is-danger is-small is-right">
            <font-awesome-icon :icon="['fa', 'exclamation-circle']" />
          </span>
          <span :class="{ 'is-danger': errors[0] }" class="help">{{
            errors[0]
          }}</span>
        </ValidationProvider>
      </div>

      <div class="form-group control">
        <input
          id="bike-model"
          v-model="_bike.model"
          type="text"
          class="input"
        />
        <label class="form-control-placeholder" for="bike-model">
          Bike Model
        </label>
      </div>

      <div class="form-group control has-icons-right">
        <ValidationProvider
          ref="bikeValueObserver"
          v-slot="{ errors }"
          rules="required|min_bike_value:400|max_bike_value:15000"
        >
          <input
            id="bike-value"
            v-model="_bike.value"
            :class="{ 'is-danger': errors[0] }"
            type="number"
            class="input"
            required
          />
          <label class="form-control-placeholder" for="bike-value">
            Bike value*
          </label>
          <span v-if="errors[0]" class="icon is-danger is-small is-right">
            <font-awesome-icon :icon="['fa', 'exclamation-circle']" />
          </span>
          <span :class="{ 'is-danger': errors[0] }" class="help">{{
            errors[0]
          }}</span>
        </ValidationProvider>
      </div>
      <IsEbike
        v-if="!hideIsEbikeRadio"
        ref="isEbike"
        :is-ebike-props="isEbike"
        @isEbikeSelected="(e) => (isEbike = e)"
      />

      <br />
      <div v-if="showWarning">
        <span class="replacement-value-error">
          <font-awesome-icon :icon="['fa', 'exclamation-circle']" />
          <span>Total Replacement value is more than 30000.</span>
        </span>
      </div>

      <button
        type="submit"
        class="button ps-button is-fullwidth"
        @click="submit()"
      >
        {{ buttonText }}
      </button>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
import IsEbike from '@/components/common/IsEbike'

export default {
  name: 'AddEditBike',
  components: { IsEbike },
  props: {
    bike: {
      type: Object,
      default: () => ({
        make: '',
        model: '',
        value: '',
      }),
    },
    buttonText: {
      type: String,
      default: 'Add Bike',
    },
    hideIsEbikeRadio: {
      type: Boolean,
      default: false
    },
  },
  data: () => {
    return {
      showWarning: false,
      isEbike: null,
    }
  },
  computed: {
    ...mapGetters({
      replacementValueSum: 'quote/replacementValueSum',
      bicycles: 'quote/bicycles',
    }),

    _bike() {
      return JSON.parse(JSON.stringify(this.bike))
    },
  },
  created() {
    this.isEbike = this.bike.isEbike
  },
  methods: {
    async submit() {
      const editedBike = this.bicycles.find(
        (bicycle) => bicycle.id === this.bike.id
      )
      let _replacementValueSum = Number(this.replacementValueSum)
      if (editedBike) {
        _replacementValueSum =
          _replacementValueSum -
          Number(editedBike.value) +
          Number(this._bike.value)
      } else {
        _replacementValueSum = _replacementValueSum + Number(this._bike.value)
      }
      if (_replacementValueSum > 30000) {
        this.showWarning = true
      } else {
        this.showWarning = false
        const bikeMake = await this.$refs.bikeMakeObserver.validate()
        const bikeValue = await this.$refs.bikeValueObserver.validate()
        const isEbike = this.hideIsEbikeRadio ? true :this.$refs.isEbike.validate()

        if (bikeMake.valid && bikeValue.valid && isEbike) {
          this.$emit('submit-bike', { ...this._bike, isEbike: this.isEbike })
        } else {
          console.log('not valid')
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.replacement-value-error {
  color: red;
}
</style>
